import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Award04 = function Award04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m8.8763 13.0953-4.175-5.2188c-.26-.3248-.39-.4873-.4823-.6682a2 2 0 0 1-.1782-.5078C4 6.5015 4 6.2935 4 5.8775V5.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C5.5198 2 6.08 2 7.2 2h9.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C20 3.5198 20 4.08 20 5.2v.6775c0 .416 0 .624-.0408.823a2 2 0 0 1-.1782.5078c-.0924.181-.2223.3434-.4822.6682l-4.175 5.2188M5.0001 3l7 9L19 3m-3.4645 10.4645c1.9527 1.9526 1.9527 5.1184 0 7.071-1.9526 1.9527-5.1184 1.9527-7.071 0-1.9526-1.9526-1.9526-5.1184 0-7.071 1.9526-1.9527 5.1184-1.9527 7.071 0"
    })
  }));
};
export default Award04;